// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kasgQ","content":"Header_content__ZUj7a"};